/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Card, Flex } from 'antd';
import { useTranslation } from 'react-i18next';
import { colors, spacing } from '../../../theming';
import { useNavigate } from 'react-router-dom';
import { routesPath } from '../../constants/routesPath';
import { useCredits } from '../../../context/CreditsContext';
import classes from './MobileTopMenu.module.scss';
import { useImpersonation } from '../../../hooks/useImpersonation';

export const MobileTopMenu = () => {
    const { t } = useTranslation(['sidebar', 'menu']);
    const navigate = useNavigate();
    const { credits } = useCredits();
    // no purchases in a read-only impersonation
    const { isImpersonating } = useImpersonation();

    return (
        <Card
            styles={{
                body: {
                    width: '100%',
                    backgroundColor: colors.white,
                    padding: spacing[3],
                },
            }}
            style={{
                borderRadius: 0,
            }}
        >
            <Flex justify="space-between" align="center">
                <Flex gap={spacing[3]}>
                    <p className={classes.creditsLabel}>{t('sidebar:my-credits')}:</p>
                    <p className={classes.creditsValue}>{credits || 0}</p>
                </Flex>

                <Button
                    className={classes.getMoreCredits}
                    type="primary"
                    size="large"
                    disabled={isImpersonating}
                    onClick={() => navigate(routesPath.ROOT.PAYMENT)}
                >
                    {t('sidebar:get-button')}
                </Button>
            </Flex>
        </Card>
    );
};
